var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.001,
    height: 100,
    viewBox: "0 0 125.001 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9397",
    "data-name": "Group 9397",
    transform: "translate(-3686.999 23959.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27410",
    "data-name": "Path 27410",
    d: "M391.25,72.378v.371H385a6.242,6.242,0,0,0-6.25,6.235v17.2a7.81,7.81,0,0,1-7.808,7.811H360.02c-.293,0-.586-.02-.879-.039-.234.02-.469.039-.7.039h-3.128a7.81,7.81,0,0,1-7.813-7.806V74.311a5.257,5.257,0,0,1,.02-.547V60.172h-6.27a6.173,6.173,0,0,1-6.25-6.1c0-.058,0-.117,0-.175a6.348,6.348,0,0,1,1.953-4.686L387.031,5.571a5.633,5.633,0,0,1,4.3-1.563,6.488,6.488,0,0,1,4.1,1.367l26.936,23.65a9.147,9.147,0,0,0-6.8,2.285,93.534,93.534,0,0,0-17.048,20.075C394.434,58,391.25,65.5,391.25,72.378",
    transform: "translate(3352 -23963.104)",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27411",
    "data-name": "Path 27411",
    d: "M445.469,44.96l-.007-.007a5.839,5.839,0,0,0-8.255.207L435,47.367l-8.981-8.981a5.972,5.972,0,0,0-4.3-1.8,5.31,5.31,0,0,0-3.281,1.133C409.707,44.5,397.5,57.778,397.5,72.758v.018a31.241,31.241,0,0,0,31.25,31.232h.018A31.241,31.241,0,0,0,460,72.758c0-6.211-3.027-16.406-14.531-27.8M428.75,94.672a12.5,12.5,0,0,1-12.5-12.5c0-7.148,7.227-14.277,10.687-17.266a2.714,2.714,0,0,1,3.613,0c3.473,3.008,10.7,10.137,10.7,17.266a12.5,12.5,0,0,1-12.5,12.5",
    transform: "translate(3352 -23963.117)",
    fill: "#fc0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/FireIcon.dbdc6bd490984ecae56b3c43fd5890e6.svg";
export { ForwardRef as ReactComponent };